import filter from '../modules/blogFilter';
import openCategory from '../modules/openCategory';

filter();
openCategory('.categoryBlog__title', '.categoryBlog__list');